<template>
  <div>
    <client-modal
      :templates="templates"
      :client="clientDetails"
      :callback="clientModified"
      :visible.sync="showClientModal"
      v-if="showClientModal"
    ></client-modal>
    <el-dialog
      custom-class="webpay urls"
      :visible.sync="showUrlsModal"
      v-if="showUrlsModal"
      top="1vh"
    >
      <div ref="urlsContent">
        {{ $t('api_url') }}:
        <a :href="urlsData.api_url">{{ urlsData.api_url }}</a>
        <br />
        {{ $t('client_id') }}: {{ selectedRow.client_id }}
        <br />
        {{ $t('api_key') }}: {{ selectedRow.api_key }}
        <br />
        {{ $t('return_url_full') }}:
        <a :href="urlsData.idcheck_url">{{ urlsData.idcheck_url }}</a>
      </div>
      <el-popover
        placement="top-start"
        width="200"
        trigger="hover"
        content="Скопировать в буфер обмена"
      >
        <el-button slot="reference" size="mini" round @click="copy">
          <i class="el-icon-share"></i>
        </el-button>
      </el-popover>
    </el-dialog>
    <el-row class="right-align" :gutter="20">
      <el-col>
        <el-button round type="primary" @click="add()">
          {{
          $t('add')
          }}
        </el-button>
        <el-button :disabled="!selectedRow" round type="primary" @click="edit">{{ $t('edit') }}</el-button>
        <el-button :disabled="!selectedRow" round type="danger" @click="remove">{{ $t('remove') }}</el-button>
        <el-button
          v-if="!!selectedRow && !selectedRow.disabled"
          round
          type="primary"
          @click="block"
        >{{ $t('block') }}</el-button>
        <el-button
          v-if="!!selectedRow && !!selectedRow.disabled"
          round
          type="primary"
          @click="unblock"
        >{{ $t('unblock') }}</el-button>
        <el-button
          :disabled="!selectedRow"
          round
          type="primary"
          @click="showUrls"
        >{{ $t('api_access') }}</el-button>
      </el-col>
    </el-row>
    <el-card>
      <el-form @submit.native.prevent="applyFilter">
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="4">
            <h4>{{ $t('filter') }}:</h4>
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.clientId" :placeholder="$t('client_id')" />
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.name" :placeholder="$t('name')" />
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.sName" :placeholder="$t('short_name')" />
          </el-col>
          <el-col :sm="5" class="aligner right">
            <el-button native-type="submit" round type="primary">
              {{
              $t('search')
              }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-table
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          highlight-current-row
          @current-change="handleSelectionChange"
        >
          <el-table-column type="expand" sortable>
            <template slot-scope="props">
              <p>{{ $t('api_key') }}: {{ props.row.api_key }}</p>
              <p>{{ $t('postback_url') }}: {{ props.row.postback_url }}</p>
              <p>{{ $t('return_url') }}: {{ props.row.return_url }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="id" width="70" label="#" sortable>
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.websdk_type == 2"
                placement="top-start"
                trigger="hover"
                content="Веб-интерфейс работает в iframe"
              >
                <img width="35" src="../../../assets/img/iframe.svg" slot="reference" alt="WebPay" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column sortable prop="client_id" width="160" :label="$t('client_id')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.client_id }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="name" :label="$t('name')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="s_name" width="210" :label="$t('short_name')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.s_name }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="custom_css" width="180" :label="$t('custom_css')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.custom_css == 1 ? $t('yes') : $t('no') }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" sortable prop="default_template" :label="$t('default_template')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ templates[scope.row.default_template] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
import apiRes from '../../core/apiRes'
import ClientModal from './ClientModal'

export default {
  name: 'idcheckClients',
  components: {
    'client-modal': ClientModal
  },
  data: () => ({
    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },
    selectedRow: null,
    showClientModal: false,
    showUrlsModal: false,
    clientDetails: {},

    pageLinks: {},
    sortLinks: {},
    clients: [],
    tableData: [],
    templates: {},
    filter: {
      name: '',
      sName: '',
      clientId: ''
    },
    urlsData: {
      api_url: '',
      idcheck_url: ''
    },
    loading: true
  }),
  created() {
    this.loadClients()
  },
  methods: {
    applyFilter() {
      let data = this.clients
      if (this.filter.name) {
        data = data.filter(c => c.name && c.name.toLowerCase().indexOf(this.filter.name.toLowerCase()) > -1)
      }
      if (this.filter.sName) {
        data = data.filter(c => c.s_name && c.s_name.toLowerCase().indexOf(this.filter.sName.toLowerCase()) > -1)
      }
      if (this.filter.clientId) {
        data = data.filter(c => c.client_id && c.client_id.toLowerCase().indexOf(this.filter.clientId.toLowerCase()) > -1)
      }
      this.tableData = data
    },
    handleSelectionChange(val) {
      this.selectedRow = val
    },
    tableRowClassName({ row, rowIndex }) {
      return row.disabled === 1 || row.disabled === '1' ? 'disabled-row' : ''
    },
    processResponse(vars) {
      if (vars) {
        // vars.res.records.forEach(r => {
        //   if (r.date_last) {
        //     r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$locale)
        //   }
        //   if (r.date_orig) {
        //     r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
        //   }
        //   r.show = false
        // })
        Object.assign(this.urlsData, vars.urls)
        this.clients = Object.keys(vars.res).map(k => vars.res[k])
        this.applyFilter()
        this.pagination = {
          total: this.clients.length,
          currentPage: 1,
          pageSize: this.clients.length
        }

        if (!this.pageLinks) this.pageLinks = {}
        if (vars.paginator) {
          if (vars.paginator.end_pages) {
            Object.keys(vars.paginator.end_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.end_pages[k]
            })
          }
          if (vars.paginator.pre_pages) {
            Object.keys(vars.paginator.pre_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.pre_pages[k]
            })
          }
          if (vars.paginator.next_pages) {
            Object.keys(vars.paginator.next_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.next_pages[k]
            })
          }
        }

        this.sortLinks = vars.account_data
      } else {
        this.clients = []
        this.tableData = []
        this.pagination = {}
      }
    },
    parseClients(promise) {
      this.loading = true
      this.clients = []
      this.tableData = []
      return promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadClients() {
      this.loading = true
      apiRes.post(apiRes.idcheckTemplates, { action: 'getShortList' }).then(res => {
        this.templates = res.page_vars.res
      })
      return this.parseClients(apiRes.post(apiRes.idcheckClients, this.filter, true))
    },
    changePage(newPage) {
      if (this.pageLinks[newPage]) {
        this.parseClients(apiRes.post(this.pageLinks[newPage]))
      }
    },
    add() {
      this.showClientModal = true
      this.clientDetails = {}
    },
    edit() {
      this.showClientModal = true
      this.clientDetails = {}
      Object.assign(this.clientDetails, this.selectedRow)
    },
    clientModified(client) {
      const clientId = client.res.data.client_id
      this.loadClients().then(() => {
        const c = this.tableData.find(c => c.client_id === clientId)
        if (c) {
          this.selectedRow = c
          this.showUrls()
        }
      })
    },
    remove() {
      this.$confirm(this.$t('alert_delete')).then(() => {
        this.loading = true
        apiRes.post(apiRes.idcheckClients, { action: 'delete', client_id: this.selectedRow.client_id }).finally(() => {
          this.loading = false
          this.loadClients()
        })
      }).catch(() => { })
    },
    block() {
      this.loading = true
      apiRes.post(apiRes.idcheckClients, { action: 'disable', client_id: this.selectedRow.client_id }).finally(() => {
        this.loading = false
        this.loadClients()
      })
    },
    unblock() {
      this.loading = true
      apiRes.post(apiRes.idcheckClients, { action: 'undisable', client_id: this.selectedRow.client_id }).finally(() => {
        this.loading = false
        this.loadClients()
      })
    },
    showUrls() {
      this.showUrlsModal = true
    },
    copy() {
      copy(this.$refs['urlsContent'].innerText)
      this.$notify.info({ message: this.$t('copied') })
    }
  }
}
</script>
<style>
.el-dialog.webpay.urls {
  max-width: 532px;
}
</style>
